export const getters = {
    getMarca: state => state.marca,
    getMarcas: state => state.marcas,
    getModalCadastroMarca: state => state.modalCadastroMarca,
    getModalExcluirMarca: state => state.modalExcluirMarca,
}

export default {}